// Created by 任泽阳 on 18/12/06. // 登录/注册/重置密码 引导框
<template>
  <section class='into-guide' :style='backgroundImg'>
    <div class='into-guide-center'>
      <div class='into-logo'>
        <img :src='intoLogoUrl' alt='' />
      </div>
      <slot />
    </div>
  </section>
</template>
<script>
export default {
  name: 'c-intoGuide',
  props: {
    imgMap: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    const { imgMap } = this;
    return {
      backgroundImg: ` background: url(${imgMap.login})#0e1a2d`,
    };
  },
  computed: {
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    intoLogoUrl() {
      return '';
    },
  },
};
</script>
<style lang='stylus' scoped>
.into-guide {
  width: 100%;
  height: 200px;
  // background: #1D2635;
  position: relative;
  background-position: left top;
  .into-guide-center {
    position: absolute;
    top: 0;
    left: 50%;
    transform:translateX(-50%);
    height: 200px;
    display: inline-block;
  }
  .into-logo {
    display: none;
  }
}
</style>
